import { CheckCircle2, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/Reveal";
import { useQuote } from "@/components/QuoteDialog";
import { socFeatures, images } from "@/mock/mock";

export default function SocSection() {
  const { openQuote } = useQuote();
  return (
    <section className="relative py-24 border-y border-white/10 bg-brand-navy2/40">
      <div className="absolute inset-0 grid-overlay opacity-30" />
      <div className="relative mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="rounded-2xl overflow-hidden border border-white/10">
            <img src={images.analysts} alt="SOC analysts at work" className="w-full h-[440px] object-cover" />
          </div>
          <div className="absolute -top-6 -right-6 hidden sm:block glass rounded-xl p-5 max-w-[180px]">
            <p className="font-display text-3xl font-bold text-brand-lime">24/7</p>
            <p className="text-xs text-slate-400 mt-1">Analysts watching your estate, every hour of every day</p>
          </div>
        </Reveal>

        <Reveal delay={100} className="order-1 lg:order-2">
          <span className="text-sm font-semibold uppercase tracking-wider text-brand-lime">SOC as a Service · MSSP</span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-bold text-white">
            A managed Security Operations Center, built for Canada
          </h2>
          <p className="mt-4 text-slate-400">
            Extend your team with our certified analysts. We monitor, detect and respond around the clock — turning overwhelming alert noise into clear, actionable protection.
          </p>
          <ul className="mt-7 space-y-4">
            {socFeatures.map((f) => (
              <li key={f} className="flex items-start gap-3 text-slate-300">
                <CheckCircle2 className="h-5 w-5 shrink-0 text-brand-lime mt-0.5" />
                <span>{f}</span>
              </li>
            ))}
          </ul>
          <Button onClick={openQuote} className="group mt-8 bg-brand-orange hover:bg-brand-orangeDark text-white font-semibold rounded-full px-7 h-12">
            Talk to our SOC team
            <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
